import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import type { AlignmentLineAxis } from '@/types/edit'


export default /*#__PURE__*/_defineComponent({
  __name: 'AlignmentLine',
  props: {
    type: {},
    axis: {},
    length: {},
    canvasScale: {}
  },
  setup(__props: any) {

const props = __props

// 吸附对齐线的位置
const left = computed(() => props.axis.x * props.canvasScale + 'px')
const top = computed(() => props.axis.y * props.canvasScale + 'px')

// 吸附对齐线的长度
const sizeStyle = computed(() => {
  if (props.type === 'vertical') return { height: props.length * props.canvasScale + 'px' }
  return { width: props.length * props.canvasScale + 'px' }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "alignment-line",
    style: _normalizeStyle({ left: left.value, top: top.value })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['line', _ctx.type]),
      style: _normalizeStyle(sizeStyle.value)
    }, null, 6)
  ], 4))
}
}

})